// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__2M_hu","tab":"UserNav_tab__1crYu"};